export default __webpack_public_path__ + "src/assets/design-1.png";